"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Icon = function Icon(_a) {
  var className = _a.className,
      name = _a.name,
      color = _a.color,
      text = _a.text,
      isSelected = _a.isSelected,
      isDisabled = _a.isDisabled,
      onClick = _a.onClick;
  className = className || "";
  var iconClass = !text ? "icon--" + name : "icon--text";
  var colorClass = !isDisabled && color ? "icon--" + color : "icon--black-3";
  var selectedClass = isSelected ? "icon--selected" : "";

  if (onClick) {
    return react_1["default"].createElement("button", {
      style: {
        backgroundColor: !isSelected ? "transparent" : ""
      },
      disabled: isDisabled,
      onClick: onClick,
      className: "icon icon--button " + iconClass + " " + colorClass + " " + selectedClass + " " + className
    }, text);
  } else {
    return react_1["default"].createElement("div", {
      className: "icon " + iconClass + " " + colorClass + " " + selectedClass + " " + className
    }, text);
  }
};

exports["default"] = Icon;